"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemLogin = void 0;
/* eslint-disable react/prefer-stateless-function */
// TODO Make SystemLogin a pure function
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var login_1 = __importDefault(require("App/pages/oidc/login"));
var SystemLogin = /** @class */ (function (_super) {
    __extends(SystemLogin, _super);
    function SystemLogin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SystemLogin.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_helmet_1.Helmet, { title: "Login" }),
            react_1.default.createElement(login_1.default.routeProps.component, null)));
    };
    return SystemLogin;
}(react_1.default.Component));
exports.SystemLogin = SystemLogin;
exports.default = {
    name: 'Login',
    routeProps: {
        path: '/login',
        component: SystemLogin,
    },
};
//# sourceMappingURL=index.js.map